import { motion } from 'framer-motion';
import styled from 'styled-components';

import Text from 'components/Text/Text';
import { setTypography } from 'utils/styles/mixins';
import { mediaDesktop } from 'utils/styles/responsive';
import { layout } from 'utils/styles/theme';

const columns = layout.columns.max;

export const Wrapper = styled(motion.div)`
  padding: 277px 0 120px;

  display: grid;
  grid-template-columns:
    [out-left] 16px
    repeat(${columns}, [content] minmax(0px, 1fr))
    [out-right] 16px;

  ${mediaDesktop(`
    grid-template-columns: [out-left] 92px repeat(${columns}, [content] minmax(0px, 1fr)) [out-right] 92px;
    grid-column-gap: 32px;
    padding: 329px 0 240px;
  `)}
`;

export const TextBlock = styled.div`
  margin-bottom: 136px;

  &:last-child {
    margin: 0;
  }
`;

export const Heading = styled(Text)`
  margin-bottom: 40px;
`;

export const RichTextWrapper = styled.div`
  word-wrap: normal;

  h1 {
    ${({ theme: { locale } }) => setTypography('heading1', locale)}
  }

  h2 {
    ${({ theme: { locale } }) => setTypography('heading2', locale)}
  }
  h3 {
    ${({ theme: { locale } }) => setTypography('heading3', locale)}
  }

  h4 {
    ${({ theme: { locale } }) => setTypography('heading4', locale)}
  }

  h5 {
    ${({ theme: { locale } }) => setTypography('heading5', locale)}
  }

  & h1,
  h2,
  h3 {
    padding-top: 96px;
    padding-bottom: 32px;

    &:first-child {
      padding-top: 0;
    }
  }

  & p {
    padding-bottom: 1em;

    &:last-child {
      padding-bottom: 0;
    }

    & + ul,
    & + ol,
    & + blockquote {
      margin-top: 14px;
    }
  }

  & h4,
  h5,
  h6 {
    padding-top: 96px;
    padding-bottom: 24px;

    &:first-child {
      padding-top: 0;
    }
  }

  & ul {
    list-style-type: disc;
    font-weight: 300;
    margin: 32px 0 32px 16px;
  }

  & ol {
    list-style-type: decimal;
    margin: 32px 0 32px 18px;
  }

  & li {
    padding: 12px 0 0 16px;

    &:first-child {
      padding-top: 0;
    }
  }

  & blockquote {
    padding-left: 32px;
    margin: 32px 0;
    border-left: 3px solid ${({ theme }) => theme.colors.black};

    &:first-child {
      margin-top: 0;
    }
  }

  & > video {
    width: 100%;
  }
`;

export const HeadingWrapper = styled.div`
  grid-column: 2/-2;
  margin-bottom: 136px;
`;

export const ContentWrapper = styled.div`
  grid-column: 2/-2;
`;

export const Subheading = styled(Text)``;
